export default [
  {
    path: '/annualReport',
    meta: { title: '2021微赞直播记忆' },
    component: () => import(/* webpackChunkName: "annualReport" */ '@/pages/annualReport/index.vue')
  },
  {
    path: '/annualReport/official',
    meta: { title: '2021微赞直播记忆' },
    component: () => import(/* webpackChunkName: "official" */ '@/pages/annualReport/official.vue')
  },
  {
    path: '/annualReport/personal',
    meta: { title: '2021微赞直播记忆' },
    component: () => import(/* webpackChunkName: "personal" */ '@/pages/annualReport/personal.vue')
  },
  {
    path: '/annualReport/entryForm',
    meta: { title: '2021微赞报名页' },
    component: () => import(/* webpackChunkName: "entryForm" */ '@/pages/annualReport/entryForm.vue')
  }
]
